import { VEHICLE_SET_LOADING } from '../actions/actionsApi'

export const initialLoadingContext = {
  vehicleExamplesLoadedOnce: false
};

export function loading(state, action) {
  if (action.type === VEHICLE_SET_LOADING) {
    return { ...state, vehicleExamplesLoadedOnce: true };
  }
  return state;
}
